import { Component, HostListener, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WaiterService } from '../../_service/waiter.service';
import { CreateCartComponent } from '../../common/create-cart/create-cart.component';
import { FormsModule } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [RouterModule, FormsModule, CommonModule, CreateCartComponent],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.scss',
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class CategoriesComponent implements OnInit {
  showScroll: boolean = false;
  private modalService = inject(NgbModal);
  orderId!: string;
  categoryId!: string;
  total = 0;
  items: any[] = [];
  page = 1;
  loading = false;
  totalPages: number = 0;
  id: any = '';
  category: any;
  cartItems: any[] = [];
  showPopup: boolean = false;
  noTable: boolean = false;
  tempItem: any;

  // Search properties
  searchTerm: string = '';
  filteredItems: any[] = [];

  // Loading states
  isCartLoading: boolean = false;
  isProductLoading: boolean = false;
  constructor(
    config: NgbModalConfig,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private app: WaiterService
  ) {
    config.centered = true
    this.route.params.subscribe(params => {
      this.categoryId = params['catId'];
    });
  }
  open(content: any) {
    this.modalService.open(content)
  }
  ngOnInit(): void {
    this.fetchAllCategoryItems();
    this.fetchCategoryDetails();
    this.updateCartItems();
  }
  cart(content: any) {
    this.isCartLoading = true;
    this.updateCartItems();

    setTimeout(() => {
      this.isCartLoading = false;
      this.modalService.open(content, {
        centered: true,
        size: 'lg',
        backdrop: 'static'
      }).result.then(
        (result) => {
          this.updateCartItems();
        },
        (dismissed) => {
          this.updateCartItems();
        }
      );
    }, 500);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.filteredItems = this.items;
  }

  updateCartItems(): void {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    this.cartItems = cart;
  }

  trackByItemId(index: number, item: any): any {
    return item.id || index;
  }

  onImageError(event: any): void {
    event.target.src = 'icons/default-product.svg';
  }

  loadMoreItems(): void {
    if (this.page < this.totalPages && !this.loading) {
      this.page++;
      this.fetchAllCategoryItems();
    }
  }
  addToCartModal(item: any, content: any) {
    this.tempItem = item;
    this.modalService.open(content, { centered: true, size: 'md' })
  }
  fetchAllCategoryItems() {
    if (this.loading) return; // Prevent multiple calls
    this.loading = true;

    // Fetch existing cart from localStorage
    let cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const storedObjectString = localStorage.getItem('orders');
    const myObject = storedObjectString ? JSON.parse(storedObjectString) : null;
    this.app.fetchInventories(this.page, this.categoryId, myObject.barcode_id).subscribe({
      next: (res: any) => {
        // Add a quantity property and inCart flag for each item
        const newItems = res.data.map((item: any) => {
          const cartItem = cart.find((cartItem: any) => cartItem.id === item.id); // Check if item is in cart
          const inCart = !!cartItem; // Set inCart flag
          const userQuantity = cartItem ? cartItem.quantity : 0; // Set userQuantity based on cart
          return { ...item, userQuantity, inCart }; // Add userQuantity and inCart fields
        });
        this.items = [...this.items, ...newItems];
        this.filteredItems = this.filterItems(this.searchTerm);
        this.totalPages = res.meta.last_page;
      },
      error: (err: any) => {
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
 // Add search methods
 onSearch(event: any): void {
  const term = event.target.value.toLowerCase();
  this.searchTerm = term;
  this.filteredItems = this.filterItems(term);
}

private filterItems(term: string): any[] {
  if (!term) return this.items;

  return this.items.filter(item =>
    item.name.toLowerCase().includes(term.toLowerCase()) ||
    (item.category && item.category.name.toLowerCase().includes(term.toLowerCase()))
  );
}
  fetchCategoryDetails() {
    this.loading = true;
    this.app.fetchCategoryDetails(this.categoryId).subscribe({
      next: (res: any) => {
        this.category = res;
      },
      error: (err: any) => {
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  capitalizeFirstLetter(word: string) {
    if (!word) return '';  // Return an empty string if the input is not valid
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
  // Increment quantity for a specific item
  increment(item: any) {
    if (item.userQuantity == 0) {
      item.userQuantity = 1;
      this.addToCart(item);
      return;
    }
    // Increase quantity in UI
    item.userQuantity += 1;

    // Retrieve the cart from localStorage
    let cart = JSON.parse(localStorage.getItem('cart') || '[]');

    // Find the item in the cart
    let cartItem = cart.find((cartItem: any) => cartItem.id === item.id);

    // Update the quantity in the cart
    if (cartItem) {
      cartItem.quantity = item.userQuantity;
    }

    // Save the updated cart back to localStorage
    localStorage.setItem('cart', JSON.stringify(cart));

    this.toastr.success(`${item.name} quantity has been increased`, 'Quantity Updated', {
      timeOut: 2000
    });
  }

  // Decrement quantity for a specific item
  decrement(item: any) {
    if (item.userQuantity > 1) {
      // Decrease quantity in UI
      item.userQuantity -= 1;

      // Retrieve the cart from localStorage
      let cart = JSON.parse(localStorage.getItem('cart') || '[]');

      // Find the item in the cart
      let cartItem = cart.find((cartItem: any) => cartItem.id === item.id);

      // Update the quantity in the cart
      if (cartItem) {
        cartItem.quantity = item.userQuantity;
      }

      // Save the updated cart back to localStorage
      localStorage.setItem('cart', JSON.stringify(cart));

      this.toastr.success(`${item.name} quantity has been decreased`, 'Quantity Updated', {
        timeOut: 2000
      });

    } else {
      // If userQuantity reaches 0, remove the item from cart
      item.userQuantity = 0;
      item.inCart = false; // Mark it as not in cart

      // Retrieve the cart from localStorage
      let cart = JSON.parse(localStorage.getItem('cart') || '[]');

      // Filter out the item from the cart
      cart = cart.filter((cartItem: any) => cartItem.id !== item.id);

      // Save the updated cart back to localStorage
      localStorage.setItem('cart', JSON.stringify(cart));

      this.toastr.info(`${item.name} has been removed from your cart`, 'Item Removed', {
        timeOut: 2000
      });
    }
  }


  addToCart(item: any) {
    if (item.quantity === 0) {
      this.toastr.warning(`${item.name} is out of stock`, 'Out of Stock', {
        timeOut: 2000
      });
      return; // Stop execution if the item is out of stock
    }

    if (item.inCart) {
      return; // Do nothing if item is already in cart
    }

    // Retrieve the existing cart from localStorage (or initialize as an empty array)
    let cart = JSON.parse(localStorage.getItem('cart') || '[]');

    // Add the new item to the cart
    cart.push({
      id: item.id,
      name: item.name,
      quantity: item.userQuantity,
      selling_price: item.selling_price,
      main_image: item.main_image,
    });

    // Save the updated cart back to localStorage
    localStorage.setItem('cart', JSON.stringify(cart));

    // Mark the item as added to the cart
    item.inCart = true;

    // Show toast notification
    this.toastr.success(`${item.name} has been added to your cart`, 'Item Added', {
      timeOut: 2000
    });
  }


  // Infinite scroll detection
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 && !this.loading) {
      if (this.page < this.totalPages) {
        this.page++; // Increment page
        this.fetchAllCategoryItems(); // Fetch next page
      }
    }
  }

  onCardScroll(card: HTMLElement) {
    // Show the button when the user scrolls down 100px or more within the card
    this.showScroll = card.scrollTop > 100;
  }

  // Scroll to the top of the card when the button is clicked
  scrollToTop(card: HTMLElement) {
    card.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
